export enum AuthenticationStatus {
  Success = 0,
  SuccessAndConnected = 1,

  InvalidPassword = 2,
  EmailAlreadyUsed = 3,
  LoginAlreadyUsed = 4,
  NationalIdAlreadyUsed = 5,

  AuthenticationError = 6,

  LinkingUserNotFound = 7,
  LinkingLoginFailed = 8,

  UnknownError = 9
}
